// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"710":"a494e49a","719":"d424ac30"}[chunkId] + ".js";
};